var path = '/Users/saulsoto/Documents/workspace/spa/spa-frontend/src/core/components/graph/graph.html';
var html = "<div style=position:relative;overflow:scroll> <svg version=1.1 id=graph xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=100% viewBox=\"0 0 1500 700\" enable-background=\"new 0 0 1000 500\" xml:space=preserve> </svg> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/core/components/graph/graph.html
// module id = 756
// module chunks = 0